@if (facade.tags$ | async; as tags) {
  <div ngbDropdown class="d-inline-block">
    <button class="d-flex align-items-center btn btn-toggle gap-half" ngbDropdownToggle>
      <web-design-system-pill type="new">
        {{ 'mydepot.depotoverview.positions.settings.newBadge' | transloco | uppercase }}
      </web-design-system-pill>
      {{ 'tags.tags-dropdown.label' | transloco }}
      @if (facade.activatedTagIds$ | async; as activatedTagIds) {
        @if (activatedTagIds?.length && tags.length) {
          <web-design-system-pill type="grey">{{ activatedTagIds?.length }}</web-design-system-pill>
        }
      }
      <web-design-system-icon name="chevron" class="icon-rotate" size="small" />
    </button>
    <div ngbDropdownMenu aria-labelledby="dropdown">
      @if (!tags.length) {
        <div class="empty-state-dropdown p-2 zero-text p-small-reg">
          {{ 'tags.tags-dropdown.empty-start' | transloco }}
          <button class="btn-icon">
            <svg class="icon icon-16 text-primary">
              <use xlink:href="/assets/img/svgs/svgset.svg#dots" />
            </svg>
          </button>
          {{ 'tags.tags-dropdown.empty-end' | transloco }}
        </div>
      } @else {
        @if (facade.activatedTagIds$ | async | allTagsActive: tags) {
          <button ngbDropdownItem class="d-flex gap-half align-items-center" (click)="facade.resetTags()">
            <web-design-system-icon name="check" />
            <div>{{ 'tags.tags-dropdown.all' | transloco }}</div>
          </button>
        } @else {
          <button ngbDropdownItem class="d-flex gap-half align-items-center" (click)="facade.activateAllTags()">
            <div class="icon-placeholder"></div>
            <div>{{ 'tags.tags-dropdown.all' | transloco }}</div>
          </button>
        }
        @for (tag of tags; track $index) {
          <button ngbDropdownItem class="d-flex justify-content-between align-items-center gap-half">
            <div class="d-flex gap-half flex-auto" (click)="facade.toggleTag(tag.tagId)">
              @if (facade.activatedTagIds$ | async | includes: tag.tagId) {
                <web-design-system-icon name="check" />
              } @else {
                <div class="icon-placeholder"></div>
              }
              <div>{{ tag.name }}</div>
            </div>
            <web-design-system-icon name="trash" color="red" size="small" (click)="facade.deleteTag(tag.tagId)" />
          </button>
        }
        <button ngbDropdownItem class="d-flex gap-half align-items-center" (click)="facade.resetTags()">
          <div class="icon-placeholder"></div>
          <div class="zero-text course-red">{{ 'tags.tags-dropdown.reset' | transloco }}</div>
        </button>
      }
    </div>
  </div>
}
